<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="16">
          <a-col :md="6" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.insurerNumber"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item label="期数">
              <a-input placeholder="请输入期数" v-model="queryParam.phase"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="10">
            <a-form-item label="录入日期">
              <a-range-picker
                style="width: 210px"
                v-model="queryParam.createTimeRange"
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item label="项目">
              <j-dict-select-tag type="list" v-model="queryParam.project" dictCode="bms_project" placeholder="请选择项目"/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item label="部门">
              <j-dict-select-tag
                placeholder="请选择部门"
                v-model="queryParam.sysOrgCode"
                dictCode="sys_depart,depart_name,org_code">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="8">
            <a-form-item label="业绩状态">
              <a-select v-model="queryParam.progress" placeholder="请选择" allowClear>
                <a-select-option v-for="item in businessStatusDict" :key="item.value" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          
          <template v-if="toggleSearchStatus">
            <a-col :md="5" :sm="6">
              <a-form-item label="保单号">
                <a-input v-model="queryParam.policy" placeholder="请输入保单号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="投保人">
                <j-search-select-tag
                  placeholder="请输入投保人"
                  v-model="queryParam.insure"
                  dict="biz_customer,name,name">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="被保人">
                <a-input placeholder="请输入被保险人" v-model="queryParam.insured"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="6">
              <a-form-item label="业务类型">
                <j-dict-select-tag
                  placeholder="请选择业务类型"
                  v-model="queryParam.businessType"
                  :options="allBusinessTypeDictOptions">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="经纪人">
                <j-search-select-tag
                  placeholder="请选择经纪人"
                  v-model="queryParam.createBy"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-form-item label="险种名称">
                <a-input placeholder="请输入险种名称" v-model="queryParam.insuranceName"/>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button type="primary" icon="download" @click="handleExport" v-has="'businessInfo:export'">导出</a-button>-->
      <a-button type="primary" icon="plus" @click="handleAddToInvoiceList" :disabled="selectedRowKeys.length === 0">
        添加到开票列表 ({{ selectedRowKeys.length }})
      </a-button>
    </div>

    <!-- table区域-begin -->
      <div class="ant-alert ant-alert-info" style="margin-bottom: 10px;height: 40px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 共查询到 <a style="font-weight: 600">{{ totalCount }}</a> 条，已确认 <a style="font-weight: 600">{{ confirmedCount }}</a> 条，已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空选择</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: 3200, y: 700 }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, onSelect: onSelect}"
        @change="handleTableChange"
        class="j-table-force-nowrap">
        
        <template slot="statusSlot" slot-scope="text">
          <a-tag v-if="text=='0'" color="red">未提交</a-tag>
          <a-tag v-else-if="text=='1'" color="green">已确认</a-tag>
          <a-tag v-else-if="text=='2'" color="orange">已退回</a-tag>
          <a-tag v-else-if="text=='3'" color="blue">已匹配</a-tag>
          <a-tag v-else-if="text=='4'" color="purple">已提交</a-tag>
        </template>
        
        <template slot="colorSlot" slot-scope="text">
          <span>{{ !text ? '': text.toLocaleString()}}</span>
        </template>
        
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button v-else type="link" size="small" @click="downloadFile(text)">下载</a-button>
        </template>
      </a-table>
    <!-- table区域-end -->
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { getAction, postAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { BusinessStatusDict_Manual } from '../enums/BusinessDict'
  import { AllBusinessTypeDictOptions } from '../enums/businessTypeDictOptions'

  export default {
    name: 'BizDirectInvoiceQuery',
    mixins: [JeecgListMixin],
    components: {
      JSearchSelectTag,
      JDictSelectTag
    },
    computed: {
      ...mapGetters('invoice', ['invoiceList']),
      totalCount() {
        return this.ipagination.total || 0
      },
      confirmedCount() {
        return this.dataSource.filter(item => item.status === '1').length
      }
    },
    data() {
      return {
        disableMixinCreated: true,
        description: '业务人员直接开票 - 条件查询',
        toggleSearchStatus: false,
        businessStatusDict: [],
        allBusinessTypeDictOptions: [],
        queryParam: {
          insurerNumber: '',
          phase: '',
          createTimeRange: [],
          project: '',
          sysOrgCode: '',
          progress: '1',
          policy: '',
          insure: '',
          insured: '',
          businessType: '',
          createBy: '',
          insuranceName: ''
        },
        lastQueryParam: {},
        ipagination: {
          current: 1,
          pageSize: 15,
          pageSizeOptions: ['5', '10', '20', '30', '50', '100'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        loading: false,
        selectedRowKeys: [],
        selectionRows: [],
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            fixed: 'left',
            align: "center",
            customRender: function(t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '业绩编号',
            className: 'column-text',
            align: "center",
            width: 200,
            fixed: 'left',
            dataIndex: 'businessNumber'
          },
          {
            title: '业绩状态',
            align: "center",
            width: 100,
            dataIndex: 'status',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '业务类型',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'businessType_dictText'
          },
          {
            title: '标的类型',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'productOrLife_dictText'
          },
          {
            title: '项目',
            className: 'column-text',
            align: "center",
            width: 280,
            dataIndex: 'project_dictText'
          },
          {
            title: '二级单位',
            className: 'column-text',
            align: "center",
            width: 180,
            dataIndex: 'insureParentOrg_dictText'
          },
          {
            title: '部门',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'sysOrgCode_dictText'
          },
          {
            title: '经纪人',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'createBy_dictText'
          },
          {
            title: '投保人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insure'
          },
          {
            title: '被保险人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insured'
          },
          {
            title: '保险人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title: '险种类型',
            className: 'column-text',
            align: "center",
            width: 270,
            dataIndex: 'insuranceType_dictText'
          },
          {
            title: '险种名称',
            className: 'column-text',
            align: "center",
            width: 180,
            dataIndex: 'insuranceName'
          },
          {
            title: '车牌号',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'car'
          },
          {
            title: '保险起期',
            align: "center",
            width: 120,
            dataIndex: 'insuranceStart',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '保险讫期',
            align: "center",
            width: 120,
            dataIndex: 'insuranceEnd',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '保额',
            align: "center",
            width: 100,
            dataIndex: 'insuredAmount',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '费率',
            align: "center",
            width: 100,
            dataIndex: 'rate',
            customRender: function(text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title: '保费',
            align: "center",
            width: 100,
            dataIndex: 'premium',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '净佣金',
            align: "center",
            width: 100,
            dataIndex: 'cleanPremium',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '是否含税',
            align: "center",
            width: 90,
            dataIndex: 'includeTax_dictText'
          },
          {
            title: '佣金比例',
            align: "center",
            width: 100,
            dataIndex: 'brokerageRatio',
            customRender: function(text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title: '总佣金',
            align: "center",
            width: 100,
            dataIndex: 'brokerageTotal',
            className: 'column-money',
            scopedSlots: { customRender: 'colorSlot' }
          },
          {
            title: '期数',
            align: "center",
            width: 80,
            dataIndex: 'phase'
          },
          {
            title: '导入时间',
            align: "center",
            width: 120,
            dataIndex: 'createTime',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '确认时间',
            align: "center",
            width: 120,
            dataIndex: 'confirmTime',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          }
        ],
        url: {
          list: "/bms/bizBusinessinfo/list",
          exportXlsUrl: "/bms/bizBusinessinfo/exportXls",
          invoice: "/bms/invoiceOperation/pushInvoiceDirect"
        },
        totalAmount: '0.00'
      }
    },
    created() {
      this.businessStatusDict = BusinessStatusDict_Manual
      this.allBusinessTypeDictOptions = AllBusinessTypeDictOptions
    },
    methods: {
      loadBusinessStatusDict() {
        this.businessStatusDict = BusinessStatusDict_Manual
      },
      onDateChange(value, dateString) {
        this.queryParam.createTimeRange = dateString
      },
      getQueryParams() {
        let sqp = {}
        if (this.queryParam.createTimeRange && this.queryParam.createTimeRange.length == 2) {
          sqp['createTime_begin'] = this.queryParam.createTimeRange[0] + ' 00:00:00'
          sqp['createTime_end'] = this.queryParam.createTimeRange[1] + ' 23:59:59'
        }
        var param = Object.assign(sqp, this.queryParam)
        param.field = this.getQueryField()
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        param.extraParam = 'all' // 发票选业绩：票内外都可选，不按报送/报备过滤
        // 转换 progress 为 status
        if (param.progress) {
          param.status = param.progress
        }
        delete param.progress
        delete param.createTimeRange
        return param
      },
      searchQuery() {
        this.lastQueryParam = Object.assign({}, this.queryParam)
        this.loadData(1)
      },
      searchReset() {
        this.queryParam = {
          insurerNumber: '',
          phase: '',
          createTimeRange: [],
          project: '',
          sysOrgCode: '',
          progress: '',
          policy: '',
          insure: '',
          insured: '',
          businessType: '',
          createBy: '',
          insuranceName: ''
        }
        this.loadData(1)
      },
      loadData(arg) {
        if (arg == 1) {
          this.ipagination.current = 1
          this.onClearSelected()
        }
        let params = this.getQueryParams()
        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
            this.calculateTotal()
          } else {
            this.$message.warning(res.message)
          }
          this.loading = false
        })
      },
      calculateTotal() {
        if (this.dataSource && this.dataSource.length > 0) {
          let total = 0
          this.dataSource.forEach(item => {
            if (item.brokerageTotal) {
              total += parseFloat(item.brokerageTotal)
            }
          })
          this.totalAmount = total.toLocaleString()
        } else {
          this.totalAmount = '0.00'
        }
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectionRows = selectionRows
        this.calculateSelectedTotal()
      },
      onSelect(record, selected, selectedRows, nativeEvent) {
        if (selected) {
          // 选中某一行，添加到选择列表
          if (!this.selectionRows.find(item => item.id === record.id)) {
            this.selectionRows.push(record)
          }
        } else {
          // 取消选中某一行，从选择列表移除
          this.selectionRows = this.selectionRows.filter(item => item.id !== record.id)
        }
        this.calculateSelectedTotal()
      },
      onClearSelected() {
        this.selectedRowKeys = []
        this.selectionRows = []
        this.totalAmount = '0.00'
      },
      calculateSelectedTotal() {
        if (this.selectionRows && this.selectionRows.length > 0) {
          let total = 0
          this.selectionRows.forEach(item => {
            if (item.brokerageTotal) {
              total += parseFloat(item.brokerageTotal)
            }
          })
          this.totalAmount = total.toLocaleString()
        } else {
          this.calculateTotal()
        }
      },
      handleExport() {
        let param = this.getQueryParams()
        let params = {
          extraParam: 'all', // 导出同样票内外全部
          ...param
        }
        getAction(this.url.exportXlsUrl, params).then((res) => {
          if (res.success) {
            let link = document.createElement('a')
            link.href = window._CONFIG['domianURL'] + res.result
            link.download = '业绩报送表.xls'
            link.click()
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      // 执行开票
      handleInvoice() {
        if (this.selectedRowKeys.length === 0) {
          this.$message.warning('请先选择要开票的业绩')
          return
        }
        
        let that = this
        this.$confirm({
          title: '确认开票',
          content: `已选择 ${this.selectedRowKeys.length} 条业绩，总佣金 ${this.totalAmount} 元，确认开票？`,
          onOk() {
            that.doInvoice()
          }
        })
      },
      doInvoice() {
        let selectedIds = this.selectedRowKeys.join(',')
        let idRelation = []
        this.selectionRows.forEach(item => {
          idRelation.push({ businessInfoId: item.id, insuranceBillId: '' })
        })

        let params = {
          idList: selectedIds,
          idRelation: idRelation
        }

        postAction(this.url.invoice, params).then((res) => {
          if (res.success) {
            this.$message.success('开票成功')
            this.onClearSelected()
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      ...mapActions('invoice', ['addToInvoiceList']),
      handleAddToInvoiceList() {
        if (this.selectionRows.length === 0) {
          this.$message.warning('请先选择要添加的业绩')
          return
        }
        // 只允许添加已确认状态的业绩
        const confirmedRows = this.selectionRows.filter(row => row.status === '1')
        if (confirmedRows.length === 0) {
          this.$message.warning('只能添加已确认状态的业绩')
          return
        }
        if (confirmedRows.length < this.selectionRows.length) {
          this.$message.warning(`已过滤非已确认状态的业绩，只添加 ${confirmedRows.length} 条`)
        }
        this.addToInvoiceList(confirmedRows)
        this.$message.success(`已添加 ${confirmedRows.length} 条业绩到开票列表`)
        this.onClearSelected()
      }
    }
  }
</script>

<style scoped>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }
  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>
